import i18next from 'i18next'

import { DIALOG_WINDOW_TYPE } from '@types'

import { getDialogWindowsFromReduxStore } from './getDialogWindowsFromReduxStore'
import { showSnackbarNotification } from './showSnackbarNotification'
import { ReturnTransformCommonParametersToValues } from './transformCommonParametersToValues'

export const checkMaxOpenedWindowsCount = (
  initialCommonParameters: ReturnTransformCommonParametersToValues
) => {
  const dialogWindows = getDialogWindowsFromReduxStore()

  const openedFormsCount = dialogWindows.filter(
    dialog =>
      [
        DIALOG_WINDOW_TYPE.VIEW,
        DIALOG_WINDOW_TYPE.FORM,
        DIALOG_WINDOW_TYPE.SECTIONAL_WINDOW,
      ].includes(dialog.type) && !dialog.hidden
  ).length

  const maxOpenedFormsCount = Number(initialCommonParameters.numberOfWindows)

  if (openedFormsCount === maxOpenedFormsCount) {
    showSnackbarNotification({
      text: i18next.t('error.dynamicFormsExceeded', { count: maxOpenedFormsCount }) as string,
      options: {
        variant: 'info',
      },
    })

    return true
  }

  return false
}
